export enum DataType {
    LoginPage,
}

const dataName = "data_name";

function getStorageData() {
    const serializedState = localStorage.getItem(dataName);

    if (serializedState === "") {
        return null;
    }

    const data = JSON.parse(serializedState);

    return data;
}

export function getData<T>(type: DataType) {
    try {
        const data = getStorageData();

        if (data == null) {
            return null;
        }

        const object = data[type];

        if (!object) {
            return null;
        }

        const parsed = JSON.parse(object);

        const typed = parsed as T;

        return typed;
    } catch (e) {
        console.log(e);

        return null;
    }
}

export function setData<T>(type: DataType, data: T) {
    try {
        let session = getStorageData();

        if (session == null) {
            session = {};
        }

        const serializedData = JSON.stringify(data);

        session[type] = serializedData;

        const serializedSession = JSON.stringify(session);

        localStorage.setItem(dataName, serializedSession);
    } catch (e) {
        console.log(e);
    }
}
